import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const notificationAudienceTypeSchema = z.enum(['all', 'user'])
export const notificationLogStatusSchema = z.enum([
  'queued',
  'sent',
  'failed',
  'partial',
])

export const createNotificationLogSchema = z.object({
  title: z.string().min(1).max(200),
  body: z.string().min(1).max(2000),
  audience_type: notificationAudienceTypeSchema.default('all'),
  target_user: z.string().optional(),
  status: notificationLogStatusSchema.default('sent'),
  sent_count: z.number().int().nonnegative().default(0),
})

export type CreateNotificationLogInput = z.infer<
  typeof createNotificationLogSchema
>

export type NotificationLogResponse = {
  id: string
  legacy_id?: string | null
  title: string
  body: string
  audience_type: 'all' | 'user'
  status: 'queued' | 'sent' | 'failed' | 'partial'
  sent_count: number
  created_at: string
  updated_at: string
}

export type PaginatedNotificationLogResponse =
  PaginatedResponse<NotificationLogResponse>
